import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { invalidateClientSession } from "@/shared/utils/authSession.util";
import { useAuth } from "@/hooks/useAuth";
import { RouteFallback } from "@/routes/RouteFallback";

type DecodedToken = {
  id: string;
  email: string;
  role: string;
  exp: number;
  iat: number;
};

export function EcosystemHeadProtectedRoute() {
  const location = useLocation();
  const { token, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <RouteFallback />;
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);

    if (decoded.role === "ADMIN" || decoded.role === "SUB_ADMIN") {
      return <Navigate to="/admin/companies" replace />;
    }

    if (decoded.role === "FACILITATOR") {
      return <Navigate to="/facilitator/dashboard" replace />;
    }

    if (decoded.role === "CLIENT" || decoded.role === "MANAGER") {
      return <Navigate to="/home" replace />;
    }

    if (decoded.role !== "ECOSYSTEM_HEAD") {
      invalidateClientSession();
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
  } catch {
    invalidateClientSession();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
}
